import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Col, Container, Row } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";

import { PageTitles } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";
import { RoutingTabs } from "../../components/RoutingTabs";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import GoalListing from "./GoalListing/GoalListing";
import GoalDetails from "./GoalDetails/GoalDetails";
import { CustomButton } from "../../components/CustomButton";
import AddGoal from "./AddGoal/AddGoal";
import UpdateGoal from "./UpdateGoal/UpdateGoal";

const GoalManagement = () => {
    const matches = useRouteMatch();
    const CONFIG = {
        tabsConfig: [
            {
                title: "",
                id: "1",
                defaultActive: false,
                exact: false,
                path: APP_ROUTES.GOAL_MANAGEMENT_ADD,
                component: <AddGoal />
            },
            {
                title: "",
                id: "2",
                defaultActive: false,
                exact: false,
                path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_EDIT, {
                    id: matches?.params?.id || 10
                }),
                component: <UpdateGoal />
            },
            {
                title: "Primary",
                id: "3",
                defaultActive: true,
                exact: true,
                path: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY,
                component: <GoalListing />,
                children: [
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_PRIMARY_EDIT, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <UpdateGoal />
                    },
                    {
                        // path: APP_ROUTES.GOAL_PRIMARY_DETAIL,
                        path: getParamsAttachedRoute(APP_ROUTES.GOAL_PRIMARY_DETAIL, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <GoalDetails />
                    }
                    // {
                    //     path: APP_ROUTES.GOAL_MANAGEMENT_ADD,
                    //     exact: false,
                    //     component: <AddGoal />
                    // },
                ]
            },

            {
                title: "Secondary",
                id: "4",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY,
                component: <GoalListing />,
                children: [
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <UpdateGoal />
                    },
                    // {
                    //     path: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_ADD,
                    //     exact: false,
                    //     component: <AddGoal />
                    // }
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.GOAL_SECONDARY_DETAIL, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <GoalDetails />
                    }
                ]
            }
        ]
    };

    const history = useHistory();
    const location = useLocation();

    const addBtnRoutes = [
        APP_ROUTES.GOAL_MANAGEMENT,
        APP_ROUTES.GOAL_MANAGEMENT_PRIMARY,
        APP_ROUTES.GOAL_MANAGEMENT_SECONDARY
    ];

    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.GOAL_MANAGEMENT}</title>
            </Helmet>
            <Container fluid>
                {addBtnRoutes?.includes(location?.pathname) ? (
                    <Row>
                        <Col sm="12" lg="12" align="right" className="mb-4">
                            <CustomButton
                                title="Add Goal"
                                color="primary"
                                icon={<i className="bx bx-plus"></i>}
                                className="custom-btn-lg"
                                onClick={() => history.push(APP_ROUTES.GOAL_MANAGEMENT_ADD)}
                            />
                        </Col>
                    </Row>
                ) : null}
                <SummaryCard
                    cardProps={{
                        style: { padding: "0px " }
                    }}
                >
                    <RoutingTabs
                        config={CONFIG}
                        isPills
                        isTabs={true}
                        parentRoute={APP_ROUTES.GOAL_MANAGEMENT}
                    />
                </SummaryCard>
            </Container>
        </div>
    );
};

export default GoalManagement;
